import { IconWrapper } from '../runtime';
export default IconWrapper('folder-application-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 20.25C1.00736 20.25 0 19.2426 0 18L0 3C0 1.75736 1.00736 0.75 2.25 0.75L6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3L21.75 3C22.9926 3 24 4.00736 24 5.25L24 18C24 19.2426 22.9926 20.25 21.75 20.25L2.25 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 22.5C1.00736 22.5 0 21.4926 0 20.25L0 7.5C0 6.25736 1.00736 5.25 2.25 5.25L21.75 5.25C22.9926 5.25 24 6.25736 24 7.5L24 20.25C24 21.4926 22.9926 22.5 21.75 22.5L2.25 22.5Z",
      "fill": 'url(#' + props.id + '2a3d8f98' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.4375 9.9375C11.4375 9.52329 11.1017 9.1875 10.6875 9.1875H8.4375C8.02329 9.1875 7.6875 9.52329 7.6875 9.9375V12.1875C7.6875 12.6017 8.02329 12.9375 8.4375 12.9375H10.6875C11.1017 12.9375 11.4375 12.6017 11.4375 12.1875V9.9375ZM11.4375 14.8125C11.4375 14.3983 11.1017 14.0625 10.6875 14.0625H8.4375C8.02329 14.0625 7.6875 14.3983 7.6875 14.8125V17.0625C7.6875 17.4767 8.02329 17.8125 8.4375 17.8125H10.6875C11.1017 17.8125 11.4375 17.4767 11.4375 17.0625V14.8125ZM12.5625 9.9375C12.5625 9.52329 12.8983 9.1875 13.3125 9.1875H15.5625C15.9767 9.1875 16.3125 9.52329 16.3125 9.9375V12.1875C16.3125 12.6017 15.9767 12.9375 15.5625 12.9375H13.3125C12.8983 12.9375 12.5625 12.6017 12.5625 12.1875V9.9375ZM16.3125 14.8125C16.3125 14.3983 15.9767 14.0625 15.5625 14.0625H13.3125C12.8983 14.0625 12.5625 14.3983 12.5625 14.8125V17.0625C12.5625 17.4767 12.8983 17.8125 13.3125 17.8125H15.5625C15.9767 17.8125 16.3125 17.4767 16.3125 17.0625V14.8125Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '2a3d8f98',
      "x1": "2.25",
      "y1": "6.43828",
      "x2": "19.1823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});